module.exports = __webpack_public_path__ + "img/textzeile-erweitern.6d4803b0.svg";